import o from"./index.module.scss.js";const s=o;export{s as PopoverTheme};
//# sourceMappingURL=index.js.map
